
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic10Static as ObiHydraulic10StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-10-static.js';
 
 
 

 
 export const ObiHydraulic10Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-10-static',
   elementClass: ObiHydraulic10StaticElement,
   events: {
     
   }
  });
 
 